import * as React from 'react';

import classnames from 'classnames';

import {RouteContext} from '../../../../../../ui/route-context';

import {colors} from '../../colors/colors';
import {ChevronDown} from '../../icon/svg/chevron-down-icon';

import styles from './section-header.module.css';

type Props = {
    icon: React.ComponentType<any> | string;
    label: string | React.ReactNode;
    isOpen: boolean;
    onClick: () => void;
};

export function SectionHeader(props: Props) {
    const isEmbedded = React.useContext(RouteContext).isEmbedded;

    const styleNames = classnames({
        [styles['section-header']]: true,
        [styles['section-header--active']]: props.isOpen,
        [styles['section-header--embedded']]: isEmbedded,
    });
    const Icon = props.icon;

    return (
        <button onClick={props.onClick} className={styleNames}>
            <div className={styles['section-header-icon']}>
                <Icon size={14} fill={colors.white} color={colors.white} wrapWithDiv={false} />
            </div>
            <div className={styles['section-header-label']}>{props.label}</div>
            <div
                style={{transform: props.isOpen ? 'rotate(0deg)' : 'rotate(270deg)'}}
                className={styles['section-header-chevron']}
            >
                <ChevronDown
                    // @ts-expect-error
                    color={props.isOpen ? colors.white : colors.navyBgActiveNew}
                    fill={props.isOpen ? colors.white : colors.navyBgActiveNew}
                    size={12}
                    wrapWithDiv={false}
                />
            </div>
        </button>
    );
}
